import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {SimpleReelModelEventData} from "../../core/reel/IReelData";
import {APIEventSystem} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {TheCryptReelView} from "./TheCryptReelView";
import {ISymbolData} from "../symbols/TheCryptSymbol";

export class TheCryptAvalancheReelModel{
    private _reelId: number;
    private _reelView: TheCryptReelView;
    public readonly events: APIEventSystem | undefined;

    constructor(id: number, triggerEvents: boolean = true) {
        this._reelId = id;
        this._reelView = new TheCryptReelView(id);
        if (triggerEvents) {
            this.events = SlotGame.apiPlugin.eventSystemFactory.create();
            this.events.on("ReelStateChange", (data: SimpleReelModelEventData) => this.onReelStateChange(data)); //To prevent event system from saving once callbacks if no on callbacks is set.
        }
    }

    public init(symbols: ISymbolData[]): void {
        this._reelView.initReel(symbols);
    }

    public reInitReels(symbols: ISymbolData[]): void {
        this._reelView.removeAllSymbols();
        this._reelView.initReel(symbols);
    }

    private onReelStateChange(data: SimpleReelModelEventData): void {
        this.events?.trigger(data.state, data);
    }

    public get reelView():TheCryptReelView{
        return this._reelView;
    }
}